module.exports = __webpack_public_path__ + "static/media/television.f2c0ec55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/television.png
// module id = 1062
// module chunks = 0